import { create } from 'zustand'
import { servicesList } from '../data/data';

const useServicesLayout = create((set) => ({
  activeIndex: 0,
  isOpen: false,
  onOpen: (id) => set({ isOpen: true, id: id }),
  onClose: () => set({ isOpen: false, id: null }),
  handleIndex: (idx) => set({ activeIndex: idx }),
  SECTION_H: 50, /* in viewport */
  sectionColor: '#000000',
  // TODO IMPLEMENT SECTION COLOR
  setSectionColor: (id) => set({sectionColor: ""}),
  isInView: false,
  inViewService: servicesList[0],
  setActiveIndex: (idx) => set({ activeIndex: idx })
}))



export default useServicesLayout;